import { defineComponent as _defineComponent } from 'vue'
import {computed, ref} from 'vue';
import {FabAction} from '@/models/interfaces/FabAction';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationFabBtn',
  props: {
    actionOrFabActions: null,
    size: { default: 60 },
    transparent: { type: Boolean },
    rightPosition: { default: 20 },
    bottomPosition: { default: 100 }
  },
  setup(__props: any) {

const props = __props as { actionOrFabActions: Function |FabAction[], size: number, transparent?: boolean, rightPosition: number, bottomPosition: number };

const fabState = ref<boolean>(false);


const isMultipleActionBtn = computed<boolean>(() => Array.isArray(props.actionOrFabActions));
const btnColor = computed<string>(() => props.transparent ? '#2b8DFA33' : 'primary');
const iconColor = computed<string>(() => props.transparent ? 'primary' : 'white');

return { __sfc: true,fabState, props, isMultipleActionBtn, btnColor, iconColor }
}

})